enum STATUS {
  VERIFICADO = 'VERIFICADO',
  ENVIADO = 'ENVIADO',
}

export default STATUS;
